module.exports = __webpack_public_path__ + "img/bg.1b01f591.png";